export function messageHasSmartDocSegmentTooltips(message) {
  return (
    (message['custom'] &&
      message['custom'].hasOwnProperty('data') &&
      message['custom']['data'].hasOwnProperty('smartdoc_segment_tooltips')) ||
    (message['config'] &&
      message['config'].hasOwnProperty('data') &&
      message['config']['data'].hasOwnProperty('smartdoc_segment_tooltips'))
  )
}

export function isStartMessage(message) {
  return (
    message['metadata'] &&
    message['metadata']['custom_info'] &&
    message['metadata']['custom_info']['template_name'] &&
    message['metadata']['custom_info']['template_name'].startsWith(
      'utter_start'
    )
  )
}

export function getCustomData(message) {
  return message['custom'] && message['custom']['data']
    ? message['custom']['data']
    : message['config'] && message['config']['data']
    ? message['config']['data']
    : message
}
